import { ApplicationState, QueryParametersState } from "@idw-types/state";
import { createSelector } from "reselect";

export const getQueryParametersState = (state: ApplicationState) => {
    return state.queryParameters;
};

export const getQueryParametersErrorCode = createSelector(getQueryParametersState, (queryParametersState: QueryParametersState) => {
    return queryParametersState.errorCode || null;
});

export const getContextPath = createSelector(getQueryParametersState, (queryParametersState: QueryParametersState) => {
    return queryParametersState.contextPath;
});

export const getQueryParametersReferenceId = createSelector(getQueryParametersState, (queryParametersState: QueryParametersState) => {
    return queryParametersState.referenceId || null;
});

export const getQueryParametersASI = createSelector(getQueryParametersState, (queryParametersState: QueryParametersState) => {
    return queryParametersState.asi || null;
});

export const getQueryParametersFlow = createSelector(getQueryParametersState, (queryParametersState: QueryParametersState) => {
    return queryParametersState.flow || null;
});

export const getQueryParametersApSessionId = createSelector(getQueryParametersState, (queryParametersState: QueryParametersState) => {
    return queryParametersState.apSessionId || null;
});